import { v4 as uuidv4 } from "uuid";
import { User } from "oidc-client-ts";
import { ICE_SSO_AUTHORITY, ICE_SSO_CLIENT_ID } from "./IceAuth";
import { getEnv } from "../../../utils/getEnv";

export function getUser() {
  const oidcStorage = localStorage.getItem(`oidc.user:${ICE_SSO_AUTHORITY}:${ICE_SSO_CLIENT_ID}`);
  if (!oidcStorage) {
    return null;
  }

  return User.fromStorageString(oidcStorage);
}

export const redirectToLogin = () => {
  window.history.pushState({}, "", "/auth/login");
};

export const redirectToLogout = () => {
  window.history.pushState({}, "", "/auth/logout");
};

export const isUserAuthenticated = async () => {
  const user = getUser();
  return user ? !user.expired : false;
};

export const getUserDetails = () => {
  let firstName: string | undefined = undefined;
  let fullName: string | undefined = undefined;
  let userName: string | undefined = undefined;
  let entityName: string | undefined = undefined;

  const user = getUser();
  const userProfile: string = user?.profile.iup as string;

  try {
    const userDetails = JSON.parse(userProfile);
    firstName = userDetails.firstName;
    fullName = `${userDetails.firstName} ${userDetails.lastName}`;
    userName = userDetails.userName;
    entityName = userDetails.companyDesc;
  } catch (_error: any) {
    // just eating the error
  }

  return {
    fullName: fullName,
    firstName: firstName,
    uid: userName,
    entityName: entityName,
  };
};

export const getTokens = () => {
  const user = getUser();
  return Promise.resolve({
    accessToken: user?.access_token,
    idToken: user?.id_token,
  });
};

export const isUserValid = () => {
  let appCompanyId: string | undefined = undefined;

  const user = getUser();
  const userProfile: string = user?.profile.iup as string;

  try {
    const userDetails = JSON.parse(userProfile);
    appCompanyId = userDetails.appCompanyId;
  } catch (_error: any) {
    // just eating the error
  }

  return appCompanyId != null;
};

export const fetchWithToken = async (uri: RequestInfo, options?: RequestInit) => {
  const apiKey = getEnv().PUBLIC_API_KEY;
  const { accessToken, idToken } = await getTokens();
  const correlationId = uuidv4();

  const newOptions: RequestInit = {
    ...options,
    headers: {
      "Content-Type": "application/json",
      "x-correlation-id": correlationId,
      ...options?.headers,
      Authorization: `Bearer ${accessToken}`,
      "x-authorization": `${idToken}`,
      "x-apikey": apiKey,
    },
  };

  // allows for multipart/form-data content types to be set automatically by the client
  // @ts-ignore
  if (options?.headers?.["Content-Type"] === "unset") {
    // @ts-ignore
    delete newOptions.headers["Content-Type"];
  }

  return fetch(uri, newOptions);
};
